import { render, staticRenderFns } from "./ReturnToPreviousStatus.vue?vue&type=template&id=9baf9ca0"
import script from "./ReturnToPreviousStatus.vue?vue&type=script&lang=js"
export * from "./ReturnToPreviousStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports